export const webAppData = [
    {
        id: '1',
        title: "JavaScript Documentation using Vanilla JS",
        thumbnail: "https://marquesfernandes.com/wp-content/uploads/2020/01/1555172.jpg",
        vlogger: "Reymond R. Mesuga",
        topics: "Deep Learning",
        info: "A JavaScript the documentation website that is part of the project in FreeCodeCamp.",
        source: "https://mesuga-reymond.github.io/Documentation-Website/",
        code: "https://github.com/mesuga-reymond/Documentation-Website"
    },
    {
        id: "2",
        title: "Random Quote Machine using React JS",
        thumbnail: "./images/quote-machine.png",
        vlogger: "Reymond R. Mesuga",
        topics: "Deep Learning",
        info: "This is a Random Quote Machine that is part of the project in FreeCodeCamp. It uses a random quote api and was made using React Js.",
        source: "https://rey-commits.netlify.app/app-projects",
        code: "https://github.com/mesuga-reymond/da-ml-portfolio-website/blob/master/src/components/RandomQuotes.js",
    },
    {
        id: "3",
        title: "Keeper App using React JS",
        thumbnail: "./images/keeper-app.png",
        vlogger: "Reymond R. Mesuga",
        topics: "Deep Learning",
        info: "This is a to-do-list app i learned from Angela Lee from Udemy and it was made using React Js.",
        source: "https://keeper-app-reymond.netlify.app/",
        code: "https://github.com/mesuga-reymond/Keeper-App-Finished",
    },
    {
        id: "4",
        title: "Former Porfolio Website Using Bootstrap",
        thumbnail: "./images/old-portfolio.png",
        vlogger: "Reymond R. Mesuga",
        topics: "Deep Learning",
        info: "This is my former personal website and online resume made in Bootstrap.",
        source: "https://mesuga-reymond.github.io/Reymond-Portfolio/",
        code: "https://github.com/mesuga-reymond/Reymond-Portfolio",
    },
    {
        id: "5",
        title: "JavaScript Calculator Using React JS",
        thumbnail: "./images/javascript-calculator.png",
        vlogger: "Reymond R. Mesuga",
        topics: "Deep Learning",
        info: "This is a simple JavaScript calculator that is part of the project in FreeCodeCamp and was made using React Js.",
        source: "https://rey-commits.github.io/JavaScript-Calculator/",
        code: "https://github.com/mesuga-reymond/JavaScript-Calculator",
    },
    {
        id: "6",
        title: "New Portfolio Website Using React JS",
        thumbnail: "./images/new-portfolio.png",
        vlogger: "Reymond R. Mesuga",
        topics: "Deep Learning",
        info: "This is the personal website that i am currently using. This was made using React JS and also the website that you are scrolling right now.",
        source: "https://rey-commits.netlify.app/",
        code: "https://github.com/mesuga-reymond/da-ml-portfolio-website"
    },
    {
        id: "7",
        title: "Color Generator App Using React JS",
        thumbnail: "./images/color-generator.png",
        vlogger: "Reymond R. Mesuga",
        topics: "Deep Learning",
        info: "This is a color generator web app i learned from John Smilga from Coding Addict. It uses React Js and Values JS to display colors.",
        source: "https://colorgenerator-reycommits.netlify.app/",
        code: "https://github.com/mesuga-reymond/color-generator"
    },
    {
        id: "8",
        title: "[Ongoing] freeCodeCamp Dummy Website",
        thumbnail: "./images/fcc-dummy.png",
        vlogger: "Reymond R. Mesuga",
        topics: "Deep Learning",
        info: "This freeCodeCamp dummy website combines the courses and video tutorials of freeCodeCamp from their official website and on youtube.",
        source: "https://fcc-dummy.netlify.app/curriculum",
        code: "https://github.com/mesuga-reymond/freecodecamp-dummy-website"
    },
]